"use client";

import { c as _c } from "react/compiler-runtime";
import { zodResolver } from "@hookform/resolvers/zod";
import { BottomSheet, BottomSheetBody, BottomSheetFooter, BottomSheetHeader, BottomSheetHeaderTitle, FlexColumn, Form, Input, Media, Popover, Separator, SpaceBetween, TextLabel } from "@opensea/ui-kit";
import { bn } from "@opensea/utils";
import { useState } from "react";
import { useForm, useFormContext, useWatch } from "react-hook-form";
import { useTranslations } from "use-intl";
import { z } from "zod";
import { Button } from "../../../../../components/Button";
import { useIsFormSubmitDisabled } from "../../../../../lib/form/valid";
import { MINIMUM_LISTING_PRICE } from "../../../constants";
const ladderSchema = z.object({
  startingPrice: z.float64().positive().optional(),
  increaseBy: z.float64().positive().optional()
});
export const LadderButton = () => {
  const $ = _c(97);
  const t = useTranslations("wallet.LadderButton");
  const [isOpen, setIsOpen] = useState(false);
  const {
    control,
    setValue: parentSetValue
  } = useFormContext();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      startingPrice: undefined,
      increaseBy: undefined
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      defaultValues: t0,
      mode: "onChange",
      resolver: zodResolver(ladderSchema)
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    register,
    handleSubmit,
    getValues,
    control: ladderControl
  } = useForm(t1);
  let t2;
  if ($[2] !== control) {
    t2 = {
      control,
      name: "listings"
    };
    $[2] = control;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const listings = useWatch(t2);
  const isFormSubmitDisabled = useIsFormSubmitDisabled(ladderControl);
  if (listings.length === 1) {
    return null;
  }
  let T0;
  let T1;
  let T2;
  let increaseByInput;
  let startingPriceInput;
  let submitButton;
  let t3;
  let t4;
  let t5;
  let t6;
  let trigger;
  if ($[4] !== getValues || $[5] !== handleSubmit || $[6] !== isFormSubmitDisabled || $[7] !== isOpen || $[8] !== listings || $[9] !== parentSetValue || $[10] !== register || $[11] !== t) {
    const submitOnEnter = e => {
      if (e.key === "Enter") {
        onSubmit();
      }
    };
    const onSubmit = () => {
      if (isFormSubmitDisabled) {
        return;
      }
      listings.forEach((_, index) => {
        parentSetValue(`listings.${index}.price`, bn(getValues("startingPrice") ?? 0).plus(bn(index).multipliedBy(bn(getValues("increaseBy") ?? 0))).toNumber(), {
          shouldValidate: true
        });
      });
      setIsOpen(false);
    };
    let t7;
    if ($[23] !== t) {
      t7 = t("ladder");
      $[23] = t;
      $[24] = t7;
    } else {
      t7 = $[24];
    }
    let t8;
    if ($[25] !== t7) {
      t8 = <Button size="sm" variant="secondary">{t7}</Button>;
      $[25] = t7;
      $[26] = t8;
    } else {
      t8 = $[26];
    }
    trigger = t8;
    const t9 = listings[0].listingSymbol;
    let t10;
    if ($[27] !== register) {
      t10 = register("startingPrice", {
        setValueAs: _temp
      });
      $[27] = register;
      $[28] = t10;
    } else {
      t10 = $[28];
    }
    startingPriceInput = <Input className="font-mono" endEnhancer={t9} onKeyDown={submitOnEnter} placeholder="0.0" size="sm" step={MINIMUM_LISTING_PRICE} type="number" {...t10} />;
    const t11 = listings[0].listingSymbol;
    let t12;
    if ($[29] !== register) {
      t12 = register("increaseBy", {
        setValueAs: _temp2
      });
      $[29] = register;
      $[30] = t12;
    } else {
      t12 = $[30];
    }
    increaseByInput = <Input className="font-mono" endEnhancer={t11} onKeyDown={submitOnEnter} placeholder="0.0" size="sm" step={MINIMUM_LISTING_PRICE} type="number" {...t12} />;
    let t13;
    if ($[31] !== t) {
      t13 = t("confirm");
      $[31] = t;
      $[32] = t13;
    } else {
      t13 = $[32];
    }
    submitButton = <Button disabled={isFormSubmitDisabled} onClick={onSubmit} size="sm">{t13}</Button>;
    let t14;
    if ($[33] !== t) {
      t14 = t("ladder");
      $[33] = t;
      $[34] = t14;
    } else {
      t14 = $[34];
    }
    let t15;
    if ($[35] !== t14) {
      t15 = <BottomSheetHeader><BottomSheetHeaderTitle>{t14}</BottomSheetHeaderTitle></BottomSheetHeader>;
      $[35] = t14;
      $[36] = t15;
    } else {
      t15 = $[36];
    }
    let t16;
    if ($[37] !== t) {
      t16 = t("startingPrice");
      $[37] = t;
      $[38] = t16;
    } else {
      t16 = $[38];
    }
    let t17;
    if ($[39] !== t16) {
      t17 = <TextLabel color="text-secondary" size="2xs">{t16}</TextLabel>;
      $[39] = t16;
      $[40] = t17;
    } else {
      t17 = $[40];
    }
    let t18;
    if ($[41] !== startingPriceInput || $[42] !== t17) {
      t18 = <FlexColumn className="grow gap-3">{t17}{startingPriceInput}</FlexColumn>;
      $[41] = startingPriceInput;
      $[42] = t17;
      $[43] = t18;
    } else {
      t18 = $[43];
    }
    let t19;
    if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
      t19 = <Separator className="h-auto flex-none" orientation="vertical" />;
      $[44] = t19;
    } else {
      t19 = $[44];
    }
    let t20;
    if ($[45] !== t) {
      t20 = t("increaseBy");
      $[45] = t;
      $[46] = t20;
    } else {
      t20 = $[46];
    }
    let t21;
    if ($[47] !== t20) {
      t21 = <TextLabel color="text-secondary" size="2xs">{t20}</TextLabel>;
      $[47] = t20;
      $[48] = t21;
    } else {
      t21 = $[48];
    }
    let t22;
    if ($[49] !== increaseByInput || $[50] !== t21) {
      t22 = <FlexColumn className="grow gap-3">{t21}{increaseByInput}</FlexColumn>;
      $[49] = increaseByInput;
      $[50] = t21;
      $[51] = t22;
    } else {
      t22 = $[51];
    }
    let t23;
    if ($[52] !== t18 || $[53] !== t22) {
      t23 = <BottomSheetBody><FlexColumn className="gap-3"><SpaceBetween className="gap-3">{t18}{t19}{t22}</SpaceBetween></FlexColumn></BottomSheetBody>;
      $[52] = t18;
      $[53] = t22;
      $[54] = t23;
    } else {
      t23 = $[54];
    }
    let t24;
    if ($[55] !== submitButton) {
      t24 = <BottomSheetFooter>{submitButton}</BottomSheetFooter>;
      $[55] = submitButton;
      $[56] = t24;
    } else {
      t24 = $[56];
    }
    let t25;
    if ($[57] !== t15 || $[58] !== t23 || $[59] !== t24) {
      t25 = <>{t15}{t23}{t24}</>;
      $[57] = t15;
      $[58] = t23;
      $[59] = t24;
      $[60] = t25;
    } else {
      t25 = $[60];
    }
    if ($[61] !== isOpen || $[62] !== t25 || $[63] !== trigger) {
      t6 = <Media lessThan="md"><BottomSheet content={t25} nested={true} onOpenChange={setIsOpen} open={isOpen}>{trigger}</BottomSheet></Media>;
      $[61] = isOpen;
      $[62] = t25;
      $[63] = trigger;
      $[64] = t6;
    } else {
      t6 = $[64];
    }
    T2 = Media;
    t5 = "md";
    T1 = Popover;
    t4 = "w-[144px] bg-bg-primary";
    T0 = Form;
    t3 = handleSubmit(onSubmit);
    $[4] = getValues;
    $[5] = handleSubmit;
    $[6] = isFormSubmitDisabled;
    $[7] = isOpen;
    $[8] = listings;
    $[9] = parentSetValue;
    $[10] = register;
    $[11] = t;
    $[12] = T0;
    $[13] = T1;
    $[14] = T2;
    $[15] = increaseByInput;
    $[16] = startingPriceInput;
    $[17] = submitButton;
    $[18] = t3;
    $[19] = t4;
    $[20] = t5;
    $[21] = t6;
    $[22] = trigger;
  } else {
    T0 = $[12];
    T1 = $[13];
    T2 = $[14];
    increaseByInput = $[15];
    startingPriceInput = $[16];
    submitButton = $[17];
    t3 = $[18];
    t4 = $[19];
    t5 = $[20];
    t6 = $[21];
    trigger = $[22];
  }
  let t7;
  if ($[65] !== t) {
    t7 = t("startingPrice");
    $[65] = t;
    $[66] = t7;
  } else {
    t7 = $[66];
  }
  let t8;
  if ($[67] !== t7) {
    t8 = <TextLabel color="text-secondary" size="2xs">{t7}</TextLabel>;
    $[67] = t7;
    $[68] = t8;
  } else {
    t8 = $[68];
  }
  let t9;
  if ($[69] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Separator />;
    $[69] = t9;
  } else {
    t9 = $[69];
  }
  let t10;
  if ($[70] !== t) {
    t10 = t("increaseBy");
    $[70] = t;
    $[71] = t10;
  } else {
    t10 = $[71];
  }
  let t11;
  if ($[72] !== t10) {
    t11 = <TextLabel color="text-secondary" size="2xs">{t10}</TextLabel>;
    $[72] = t10;
    $[73] = t11;
  } else {
    t11 = $[73];
  }
  let t12;
  if ($[74] !== increaseByInput || $[75] !== startingPriceInput || $[76] !== submitButton || $[77] !== t11 || $[78] !== t8) {
    t12 = <FlexColumn className="gap-3">{t8}{startingPriceInput}{t9}{t11}{increaseByInput}{submitButton}</FlexColumn>;
    $[74] = increaseByInput;
    $[75] = startingPriceInput;
    $[76] = submitButton;
    $[77] = t11;
    $[78] = t8;
    $[79] = t12;
  } else {
    t12 = $[79];
  }
  let t13;
  if ($[80] !== T0 || $[81] !== t12 || $[82] !== t3) {
    t13 = <T0 onSubmit={t3}>{t12}</T0>;
    $[80] = T0;
    $[81] = t12;
    $[82] = t3;
    $[83] = t13;
  } else {
    t13 = $[83];
  }
  let t14;
  if ($[84] !== T1 || $[85] !== isOpen || $[86] !== t13 || $[87] !== t4 || $[88] !== trigger) {
    t14 = <T1 className={t4} content={t13} onOpenChange={setIsOpen} open={isOpen} portal={false}>{trigger}</T1>;
    $[84] = T1;
    $[85] = isOpen;
    $[86] = t13;
    $[87] = t4;
    $[88] = trigger;
    $[89] = t14;
  } else {
    t14 = $[89];
  }
  let t15;
  if ($[90] !== T2 || $[91] !== t14 || $[92] !== t5) {
    t15 = <T2 greaterThanOrEqual={t5}>{t14}</T2>;
    $[90] = T2;
    $[91] = t14;
    $[92] = t5;
    $[93] = t15;
  } else {
    t15 = $[93];
  }
  let t16;
  if ($[94] !== t15 || $[95] !== t6) {
    t16 = <>{t6}{t15}</>;
    $[94] = t15;
    $[95] = t6;
    $[96] = t16;
  } else {
    t16 = $[96];
  }
  return t16;
};
function _temp(value) {
  return value ? Number.parseFloat(value) : undefined;
}
function _temp2(value_0) {
  return value_0 ? Number.parseFloat(value_0) : undefined;
}